const E = {
  SelectCriteria: 'Select Criteria',
  CustomReport: 'Custom Report',
  Filter: 'Filter',
  All: 'All',
  Select: 'Select',
  'Client Number': 'Client Number',
  'Company Name': 'Company Name',
  Facility: 'Facility',
  Total: 'Total',
  Next: 'Next',
  To: 'To',
  From: 'From',
  Selected: 'Selected',
  Clients: 'Clients',
  Jobs: 'Jobs',
  Samples: 'Samples',
  Parameters: 'Parameters',
  SelectAll: 'Select All',
  Reports: 'Reports',
  SelectDateType: 'Select Date Type',
  'REPORT FORMAT': 'REPORT FORMAT',

  'Job Received Date': 'Job Received Date',
  'Deadline Date': 'Deadline Date',
  'Sampling Date': 'Sampling Date',
  'Enhanced (Samples as Columns)': 'Enhanced (Samples as Columns)',
  'Dynamic parameter as column': 'Dynamic parameter as column',

  'Column Headers': 'Column Headers',
  'Sample Information Analytical Results': 'Sample Information, Analytical Results',
  'and Detection Limits': 'and Detection Limits',
  errorMessage: 'Sorry, We can not find any Report Formats for your selected clients.',
  dateMessage: 'Sorry, From date cannot be greater than To date.',

  // Step 3
  'Job Number': 'Job Number',
  'Received On': 'Received On',
  'Project #': 'Project #',
  'PO #': 'PO #',
  'Site Location': 'Site Location',
  'Report Company': 'Report Company',
  'Report Attention': 'Report Attention',
  'Invoice Attention': 'Invoice Attention',
  NoJobs: 'There are no jobs found based on your report and date selection.',

  // Step 4
  'Sample ID': 'Sample ID',
  'Sample Date': 'Sample Date',
  'Sample #': 'Sample #',
  Matrix: 'Matrix',
  Description: 'Description',
  'Alt Sample ID': 'Alt.Sample ID',
  NoSamples: 'There are no samples found based on your jobs.',

  // Step 5
  NoParameters: 'There are no parameters found based on your samples.',

  // Step 6
  'Create Report': 'Create Report',
  'Criteria 1': 'Criteria 1',
  'Criteria 2': 'Criteria 2',
  'Policy Level': 'Policy Level',
  'Display Order': 'Display Order',
  'Report Name': 'Report Name',
  'ALSO SEND REPORT TO': 'ALSO SEND REPORT TO',
  'Email Recipient List': 'Email Recipient List',

  // Step 2
  'Analytical Results': 'Analytical Results',
  'and Criteria Result': 'and Criteria Result',
  'Enhanced (Parameters as Columns)': 'Enhanced (Parameters as Columns)',
  Standard: 'Standard',
  SampleReport_ParameterAsColumns: {
    vertical: [
      'Sample 1 Information',
      'Sample 2 Information',
      'Sample 3 Information',
    ],
    horizontal: ['Parameter  1 Information', 'Parameter  2 Information'],
    text: 'and Detection Limits',
  },
  SampleReport_SamplesAsColumns: {
    vertical: ['Parameter 1 Info', 'Parameter 2 Info', 'Parameter 3 Info'],
    horizontal: ['Sample 1 Information', 'Sample 2 Information'],
    text: 'and Detection Limits',
  },
  SampleReport_Trending: {
    vertical: [
      'Parameter 1 Results',
      'Parameter 1 Criteria',
      'Parameter 2 Results',
      'Parameter 2 Criteria',
    ],
    horizontal: ['Sample 1 Information', 'Sample 2 Information'],
    text: 'and Criteria Values',
  },
  SampleReport_Condensed: {
    vertical: [
      'Sample 1 Information',
      'Sample 2 Information',
      'Sample 3 Information',
    ],
    horizontal: ['Parameter 1 Information', 'Parameter 2 Information'],
    bottomHorizontal: ['Parameter 1 Statistics', 'Parameter 2 Statistics'],
    text: '',
  },
  SampleObservation: ['Summary Table', 'Observation Details'],
  DynamicObservations: [
    'Summary Analysis Table',
    'Results Tables',
    'Min / Max Values',
    'Exceedance Summary',
    'Date Summary',
  ],
  Descriptions_ParameterAsColumns: {
    description: 'The Parameters as Columns format lists sample information on the left hand side of the table and parameters across the top. It is ideal if you are reporting only a few parameters and many samples:',
    li: [
      'Supports up to 2 Criteria.',
      'RDL listed for each sample and parameter.',
    ],
  },
  Descriptions_SamplesAsColumns: {
    description: 'The Samples as Columns format lists parameters on the left hand side of the table and sample information is displayed across the top. It is ideal if you are reporting only a few samples and many parameters:',
    li: [
      'Supports up to 2 Criteria.',
      'RDL listed for each sample and parameter.',
    ],
  },
  Descriptions_DataTable: {
    description: 'The Data Table lists all of the information in a more traditional data table format. Each row of data contains the result for one parameter of a selected sample:',
    li: [
      'Supports one Criteria.',
      'Volume limited to the amount of data that can be selected in the report wizard.',
      'RDL listed for each sample and parameter.',
    ],
  },
  Descriptions_Trending: {
    description: 'The Trending Report outputs data in a manner that is more conducive to generating graphs. Samples are listed in ascending chronological order based on sampling date:',
    li: [
      'Supports one Criteria.',
      'Non-detect results are converted to the detection limit in a numerical format.',
      'Convenient for using min/max excel formulas.',
    ],
  },
  Descriptions_SampleObservations: {
    description: 'The Sample Observations report provides both a summary and detailed view into your team’s submission statistics. It’s a fast and easy way to see the most frequently observed FLAGs within a project or time period. The output includes:',
    li: [
      'A summary tab that provides monthly volumes by FLAG',
      'A details tab that includes all pertinent information and resolution comments in a data table format.',
    ],
  },
  Descriptions_Condensed: {
    description: 'The Condensed report format lists sample information on the left hand side of the table and parameters across the top. It also provides additional statistics about the samples for a given parameter in the data set:',
    li: ['Supports up to 2 Criteria.'],
  },
  Descriptions_Default: {
    description: 'The Dynamic Report places the results into customized groups and worksheets: ',
    li: [
      'Supports up to 2 Criteria Polices.',
      'Volume limited to the amount of data that can be selected in the report wizard.',
      'Multiple summary tables to assist with data review.',
    ],
  },
};

const F = {
  SelectCriteria: 'Sélectionner des critères',
  CustomReport: 'Rapport personnalisé',
  Filter: 'Filtrer',
  Standard: 'Standard',
  All: 'Tout',
  Select: 'Sélectionner',
  'Client Number': 'Numéro de client',
  'Company Name': 'Nom de l’entreprise',
  Facility: 'Installations',
  Total: 'Total',
  Next: 'Suivant',
  Selected: 'Sélectionné',
  Reports: 'Rapports',
  To: 'À',
  From: 'De',
  Jobs: 'Dossiers',
  SelectAll: 'Sélectionner tout',
  Samples: 'Échantillons',
  Parameters: 'Paramètres',
  SelectDateType: 'Choisir le type de date',
  'REPORT FORMAT': 'FORMAT DU RAPPORT',

  'Job Received Date': 'Date de réception du travail',
  'Deadline Date': 'Date limite',
  'Sampling Date': "Date d'échantillonnage",

  'Enhanced (Samples as Columns)': 'Amélioré (échantillons par colonne)',
  'Enhanced (Parameters as Columns)': 'Amélioré (paramètres par colonne)',

  'Column Headers': 'En-têtes de colonne',
  'Sample Information Analytical Results': 'Exemple d’information, résultats d’analyse et limites de détection',
  'and Detection Limits': 'et limites de détection',
  errorMessage: 'Désolé, aucun format de rapport ne correspond aux clients sélectionnés.',
  dateMessage: 'Désolé, la date de début ne peut pas dépasser la date de fin.',

  // Step 3
  'Job Number': 'Numéro de dossier',
  'Received On': 'Reçu le',
  'Project #': 'No de projet',
  'PO #': 'No de PO',
  'Site Location': 'Emplacement du site',
  'Report Company': 'Entreprise',
  'Report Attention': 'Envoyer le rapport à',
  'Invoice Attention': 'Envoyer la facture à',
  NoJobs: 'Aucun dossier ne correspond au rapport et à la date sélectionnés.',

  // Step 4
  'Sample ID': 'ID de l’échantillon',
  'Sample Date': 'Date de l’échantillon',
  'Sample #': 'No d’échantillon',
  Matrix: 'Matrice',
  Description: 'Description',
  'Alt Sample ID': 'ID de l’échantillon alt.',
  NoSamples: 'Aucun échantillon ne correspond aux dossiers sélectionnés.',

  // Step 5
  NoParameters: 'Aucun paramètre ne correspond aux échantillons sélectionnés.',

  // Step 6

  'Create Report': 'Créer un rapport',
  'Criteria 1': 'Critère 1',
  'Criteria 2': 'Critère 2',
  'Policy Level': 'Niveau politique',
  'Display Order': "Ordre d'affichage",
  'Report Name': 'Titre du rapport',
  'ALSO SEND REPORT TO': 'ENVOYER AUSSI À',
  'Email Recipient List': 'Liste de destinataires',

  // Step 2
  'Analytical Results': 'Résultats d’analyse ',
  'and Criteria Result': 'et résultat des critères',
  SampleReport_ParameterAsColumns: {
    vertical: [
      'Information sur l’échantillon 1',
      'Information sur l’échantillon 2',
      'Information sur l’échantillon 3',
    ],
    horizontal: ['Information du paramètre 1', 'Information du paramètre 2'],
    text: 'et limites de détection',
  },
  SampleReport_SamplesAsColumns: {
    vertical: ['Information sur le paramètre 1', 'Information sur le paramètre 2', 'Information sur le paramètre 3'],
    horizontal: [
      'Information sur l’échantillon 1',
      'Information sur l’échantillon 2',
    ],
    text: 'et limites de détection',
  },
  SampleReport_Trending: {
    vertical: [
      'Résultats du paramètr 1',
      'Critères du paramètre 1',
      'Résultats du paramètr 2',
      'Critères du paramètre 2',
    ],
    horizontal: [
      'Information sur l’échantillon 1',
      'Information sur l’échantillon 2',
    ],
    text: 'et valeurs de critères',
  },
  SampleReport_Condensed: {
    vertical: [
      'Information sur l’échantillon 1',
      'Information sur l’échantillon 2',
      'Information sur l’échantillon 3',
    ],
    horizontal: ['Information du paramètre 1', 'Information du paramètre 2'],
    bottomHorizontal: [
      'Statistiques du paramètre 1',
      'Statistiques du paramètre 2',
    ],
    text: '',
  },
  SampleObservation: ['Tableau récapitulatif', 'Information sur l’observation'],
  DynamicObservations: [
    'Sommaire des analyses', 'Tableaux de résultats', 'Valeurs min/max', 'Sommaire des dépassements', 'Sommaire des dates',
  ],
  Descriptions_ParameterAsColumns: {
    description: 'Le format Paramètres par colonne affiche l’information sur l’échantillon dans la colonne de gauche et les paramètres dans l’en-tête. Idéal si seulement quelques paramètres sont démandés pour plusieurs échantillons: ',
    li: [
      'Permet d’afficher jusqu’à 2 critères.',
      'LDR pour chaque échantillon et chaque paramètre.',
    ],
  },
  Descriptions_SamplesAsColumns: {
    description: 'Le format Échantillons par colonne affiche les paramètres dans la colonne de gauche et l’information sur l’échantillon dans l’en-tête. Idéal si seulement quelques échantillons sont démandés pour plusieurs paramètres: ',
    li: [
      'Permet d’afficher jusqu’à 2 critères.',
      'LDR pour chaque échantillon et chaque paramètre.',
    ],
  },
  Descriptions_DataTable: {
    description: 'Le tableau de données affiche l’information dans un format plus traditionnel. Chaque ligne indique le résultat d’un paramètre pour l’échantillon sélectionné: ',
    li: [
      'Permet d’afficher un critère',
      'Le nombre est limité par la quantité de données que l’Assistant Rapport permet de sélectionner.',
      'LDR pour chaque échantillon et chaque paramètre.',
    ],
  },
  Descriptions_Trending: {
    description: 'Le rapport des tendances affiche les données dans un format plus propice à la création de graphiques. Les échantillons sont en ordre chronologique de date d’échantillonnage: ',
    li: [
      'Prend en charge un critère.',
      ' Les résultats non détectés sont convertis en limite de détection et s’affichent en chiffre.',
      'Idéal pour les formules Excel min/max.',
    ],
  },
  Descriptions_SampleObservations: {
    description: 'Le rapport des observations de l’échantillon affiche le sommaire et l’information détaillée des statistiques relatives aux envois de votre équipe: ',
    li: [
      'Permet de repérer rapidement et facilement les FLAG les plus fréquents pour un projet ou pour une période précise',
      'Contient un onglet avec le sommaire des récurrences mensuelles de chaque FLAG, un onglet avec toute l’information pertinente et les commentaires de résolution sous forme de tableau.',
    ],
  },
  Descriptions_Condensed: {
    description: 'Le format Condensé affiche l’information sur l’échantillon dans la colonne de gauche et les paramètres dans l’en-tête. Donne également d’autres statistiques sur les échantillons pour un paramètre précis de l’ensemble de données: ',
    li: ['Permet d’afficher jusqu’à 2 critères.'],
  },
  Descriptions_Default: {
    description: 'Le rapport dynamique met les résultats dans des groupes et des feuilles de calcul personnalisés:',
    li: [
      "Prend en charge jusqu'à 2 stratégies de critères.",
      'Le nombre est limité par la quantité de données que l’Assistant Rapport permet de sélectionner.',
      'Plusieurs sommaires pour faciliter la vérification des données.',
    ],
  },
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/reportForms.js